// Module
var code = "<react-component name=\"ContactUsFormSubmissionsReport\"></react-component>\n";
// Exports
module.exports = code;